define.alias("shared/components/shared/post/secondary/hashtag-suggestions/table", "calendar/components/shared/post/secondary/hashtag-suggestions/table");